<div class="alert-danger">
  <div>&nbsp;</div>
  <span class="text text-white text-center px-2 py-1" i18n="@@public.project.warning">PUBLIC PROJECT: Anyone can see contents of this project. Do no store any sensitive data in this project.</span>
  <div class="px-3 py-1 text-white-50 hover-scale d-flex align-items-center cursor-pointer" (click)="onDismiss()"><i class="fal fa-times" i18n-title="@@button.dismissClose" title="Dismiss"></i></div>
</div>
